import { images } from ".";

const events = [
    {
        id: 1,
        image: images.event1,
        title: "Wedding Ceremony",
        details: {
            location: "Various Venues Available",
            priceRange: "$5,000 - $7,000",
            includes: "Full-service catering, premium bar, decor options",
            duration: "6:00 PM - 11:00 PM",
            booking: "Minimum 2 months in advance",
            specialFeatures: "Personalized event planning, exclusive menu options",
            eventThemes: "Rustic, Vintage, Modern, Classic, Garden, Beach, Glamorous, Cultural"
        },
        overviews: [
            "Experience the perfect blend of elegance and romance with our bespoke wedding ceremonies, meticulously crafted to reflect your unique love story.",
            "Our dedicated wedding planning team ensures every detail of your ceremony reflects your personal style and vision. Whether you dream of a traditional indoor ceremony or a modern outdoor celebration, we manage every element—venue selection, decor, catering, and entertainment—to bring your special day to life effortlessly."
        ],
        gallery: [
            images.event1Gallery1,
            images.event1Gallery2,
            images.event1Gallery3,
            images.event1Gallery4,
            images.event1Gallery5,
            images.event1Gallery6,
        ],
        features: [
            "Tailored Venue Selection and Customization",
            "Exclusive Floral and Decor Arrangements",
            "Comprehensive Catering and Menu Planning",
            "Professional Music and Entertainment Services",
            "Photography and Videography by Top-Tier Vendors"
        ],
        customizations: [
            "Curated Decor Themes and Styles",
            "Custom Floral Designs by Leading Experts",
            "Innovative Lighting and Atmosphere Creations",
            "Personalized Catering Menus to Suit Any Palate"
        ],
        highlights: [
            "Breathtaking Venue Transformations",
            "Seamless Event Coordination and Execution",
            "Stress-Free Planning for an Unforgettable Day"
        ],
    },
    {
        id: 2,
        image: images.event2,
        title: "Reception Party",
        details: {
            location: "Various Venues Available",
            priceRange: "$4,000 - $6,500",
            includes: "Custom menu, bar service, venue decor",
            duration: "7:00 PM - 12:00 AM",
            booking: "Minimum 2 months in advance",
            specialFeatures: "Theme-based setup, entertainment coordination",
            eventThemes: "Elegant, Modern, Classic, Garden, Glamorous, Cultural"
        },        
        overviews: [
            "Celebrate your union in style with our unforgettable reception parties, tailored to your theme, style, and vision. We deliver an evening filled with joy, laughter, and lasting memories.",
            "From grand ballrooms to intimate garden settings, our team curates each element—lighting, music, catering, and decor—to ensure a spectacular post-wedding celebration."
        ],
        gallery: [
            images.event2Gallery1,
            images.event2Gallery2,
            images.event2Gallery3,
            images.event2Gallery4,
            images.event2Gallery5,
            images.event2Gallery6,
        ],
        features: [
            "Custom Theme Design and Decor",
            "Live Music or DJ Entertainment",
            "Premium Beverage Packages",
            "Personalized Menu Options",
            "Coordinated Guest Seating and Flow"
        ],
        customizations: [
            "Mood Lighting and Effects",
            "Cultural or Fusion Entertainment",
            "Signature Cocktails and Bar Setups",
            "Table Styling with Unique Centerpieces",
            "Interactive Food Stations"
        ],
        highlights: [
            "Stylish Venue Ambiance",
            "Seamless Event Flow",
            "Exceptional Dining Experience",
            "Engaging Entertainment",
            "Photo-Worthy Moments Throughout"
        ],
    },
    {
        id: 3,
        image: images.event3,
        title: "Bridal Shower",
        details: {
            location: "Indoor & Outdoor Venues",
            priceRange: "$2,000 - $4,000",
            includes: "Light catering, themed decor, desserts",
            duration: "3 to 4 hours",
            booking: "Minimum 1 month in advance",
            specialFeatures: "Personalized games, floral arrangements",
            eventThemes: "Romantic, Boho Chic, Elegant, Pastel, Vintage"
        },        
        overviews: [
            "Celebrate the bride-to-be with an intimate and elegant bridal shower designed to reflect her unique personality. We craft every detail from the theme to the treats with charm and care.",
            "From delightful desserts to curated games and stylish decor, our team ensures a memorable pre-wedding celebration for the bride and her closest friends and family."
        ],
        gallery: [
            images.event3Gallery1,
            images.event3Gallery2,
            images.event3Gallery3,
            images.event3Gallery4,
            images.event3Gallery5,
            images.event3Gallery6,
        ],
        features: [
            "Custom Shower Themes and Decor",
            "Artisanal Finger Foods and Sweets",
            "Personalized Gift Table Setup",
            "Elegant Tableware and Florals",
            "Fun and Interactive Shower Games"
        ],
        customizations: [
            "Personalized Invitations",
            "DIY Craft Stations",
            "Themed Photo Backdrops",
            "Custom Cake and Dessert Table",
            "Bridal Trivia and Icebreakers"
        ],
        highlights: [
            "Relaxed and Joyful Ambience",
            "Thoughtful Attention to Details",
            "Chic Styling and Table Decor",
            "Delectable Bite-sized Treats",
            "Bride-Centered Experiences"
        ],
    },
    {
        id: 4,
        image: images.event4,
        title: "Engagement Party",
        details: {
            location: "Banquet Hall or Garden Venue",
            priceRange: "$3,500 - $7,000",
            includes: "Full-course catering, themed decorations, music setup",
            duration: "4 to 5 hours",
            booking: "Recommended 1–2 months in advance",
            specialFeatures: "Couple spotlight area, engagement cake, toast setup",
            eventThemes: "Modern Glam, Rustic Romance, Classic Elegance, Sunset Soirée"
        },        
        overviews: [
            "Mark the beginning of your forever with an unforgettable engagement party surrounded by friends and family. Our team takes care of every detail to match your style and vision.",
            "Celebrate your love story with stunning decor, gourmet food, and a vibrant atmosphere that sets the perfect tone for the journey ahead."
        ],
        gallery: [
            images.event4Gallery1,
            images.event4Gallery2,
            images.event4Gallery3,
            images.event4Gallery4,
            images.event4Gallery5,
            images.event4Gallery6,
        ],
        features: [
            "Elegant Venue Styling",
            "Gourmet Catering Options",
            "Signature Engagement Cake",
            "Live Music or DJ Setup",
            "Dedicated Couple Seating Area"
        ],
        customizations: [
            "Personalized Signage",
            "Engagement Video Montage",
            "Guestbook and Memory Table",
            "Custom Cocktails and Mocktails",
            "Photobooth with Couple Branding"
        ],
        highlights: [
            "Romantic and Festive Setting",
            "Celebration of Love and Unity",
            "Warm and Welcoming Atmosphere",
            "Delicious Menu Choices",
            "Flawlessly Coordinated Event"
        ],
    },
    {
        id: 5,
        image: images.event5,
        title: "Bachelorette Party",
        details: {
            location: "Private Lounge, Beachside Venue, or Rooftop Bar",
            priceRange: "$2,000 - $6,000",
            includes: "Drinks and appetizers, theme décor, music entertainment",
            duration: "4 to 6 hours",
            booking: "Recommended 2–4 weeks in advance",
            specialFeatures: "Custom party props, dance floor, VIP lounge setup",
            eventThemes: "Glam Night Out, Spa Retreat, Tropical Bash, Boho Chic"
        },
        overviews: [
            "Celebrate the bride-to-be with a high-energy and unforgettable bachelorette party tailored to her style. Whether it's a wild night out or a chic private gathering, we make it fabulous.",
            "From cocktails to custom décor and entertainment, every detail is handled to make the last fling before the ring a night to remember."
        ],
        gallery: [
            images.event5Gallery1,
            images.event5Gallery2,
            images.event5Gallery3,
            images.event5Gallery4,
            images.event5Gallery5,
            images.event5Gallery6,
        ],
        features: [
            "Exclusive Party Setup",
            "Signature Drinks and Bites",
            "Custom Decor and Props",
            "Music and Dance Area",
            "Bride Tribe Accessories"
        ],
        customizations: [
            "Personalized Party Favors",
            "Live DJ or Karaoke",
            "Private Mixology Session",
            "Spa and Beauty Add-ons",
            "Photo Wall with Bride’s Name"
        ],
        highlights: [
            "Fun and Stylish Celebration",
            "Bride-Centered Experiences",
            "Lively Atmosphere",
            "Memorable Photo Moments",
            "Tailored Entertainment Options"
        ],
    },
    {
        id: 6,
        image: images.event6,
        title: "Rehearsal Dinner",
        details: {
            location: "Private Dining Room, Garden Venue, or Banquet Hall",
            priceRange: "$2,500 - $8,000",
            includes: "Multi-course dinner, welcome drinks, table décor",
            duration: "3 to 4 hours",
            booking: "Recommended 1 month in advance",
            specialFeatures: "Custom seating arrangements, couple’s slideshow",
            eventThemes: "Elegant Evening, Rustic Charm, Classic Celebration"
        },
        overviews: [
            "Set the tone for the big day with a beautifully arranged rehearsal dinner. A perfect time for the wedding party and close family to gather, share stories, and enjoy a memorable meal together.",
            "We craft intimate and sophisticated rehearsal dinners that blend great food, thoughtful ambiance, and personal touches for an unforgettable pre-wedding evening."
        ],
        gallery: [
            images.event6Gallery1,
            images.event6Gallery2,
            images.event6Gallery3,
            images.event6Gallery4,
            images.event6Gallery5,
            images.event6Gallery6,
        ],
        features: [
            "Private Dining Ambiance",
            "Custom Menu Options",
            "Table and Floral Decor",
            "Toasts and Speeches Setup",
            "Couple’s Photo or Slideshow"
        ],
        customizations: [
            "Family-Style or Plated Meals",
            "Live Acoustic Music",
            "Welcome Signage",
            "Personalized Menus",
            "Themed Table Settings"
        ],
        highlights: [
            "Intimate and Elegant Setting",
            "Perfect Pre-Wedding Gathering",
            "Warm and Relaxed Vibe",
            "Thoughtful Personalization",
            "Seamless Coordination"
        ],
    },
];

export default events;